import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {ApiRouteConfig} from '../../../config/api.route.config';
import {
  ChappListLoadResponse,
} from "@npm.chapps.com/chapps.common.angular.library/lib/components/chapps-list/interfaces/any-chapps-list-load-response";
import {InterventionTeamDetailDto} from '../../maintenance/intervention-teams/teams/intervention-team-detail.dto';


@Injectable()
export class InterventionTeamService {
  constructor(private httpClient: HttpClient, private config: ApiRouteConfig) {
  }

  public getAll(): Observable<ChappListLoadResponse<InterventionTeamDetailDto>> {

    return this.httpClient.get<ChappListLoadResponse<InterventionTeamDetailDto>>(this.config.INTERVENTION_TEAMS_ALL);
  }
}
